import { createCollectionCursorStyles } from './collectionCursorFrames';

// The frame assets are shared by every collection and survive route changes.
export function ensureCollectionCursorStyles(doc = document) {
  if (doc.getElementById('collection-cursor-frames')) return;
  const sheet = doc.createElement('style');
  sheet.id = 'collection-cursor-frames';
  sheet.textContent = createCollectionCursorStyles();
  doc.head.appendChild(sheet);
}
